import ZkAreaSaveOrUpdate from './src/main.vue'
ZkAreaSaveOrUpdate.install = function (Vue) {
  Vue.component(ZkAreaSaveOrUpdate.name, ZkAreaSaveOrUpdate)
}

export default ZkAreaSaveOrUpdate



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/areaSaveOrUpdate/index.js